import { props, createActionGroup, emptyProps } from '@ngrx/store';
import { DeliveryAddress } from '@us/web/shared/data-access';

export const DeliveryAddressesActions = createActionGroup({
    source: 'Delivery Addresses/API',
    events: {
        'Load Delivery Addresses': emptyProps(),
        'Load Delivery Addresses Success': props<{ deliveryAddresses: DeliveryAddress[] }>(),
        'Load Delivery Addresses Failure': props<{ error: any }>(),
        'Create Delivery Address': props<{ deliveryAddress: DeliveryAddress }>(),
        'Create Delivery Address Success': props<{ deliveryAddress: DeliveryAddress }>(),
        'Create Delivery Address Failure': props<{ error: any }>()
    }
});
